import { secondaryColors } from '@tryhackme/thm-ui-components';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

export const StyledAppearAnimation = css`
  @keyframes appear {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const StyledModule = styled(Link)<{ $isDark: boolean }>`
  width: 100%;
  padding: 1.6rem 0.8rem;
  display: flex;
  flex-wrap: no-wrap;
  gap: 1.2rem;
  align-items: center;
  color: ${({ theme }) => theme.colors.text.main};
  border-radius: 0.8rem;
  text-decoration: none;
  transition: opacity 0.3s ease-in-out;
  ${StyledAppearAnimation};

  &:hover {
    background-color: ${({ theme }) => theme.colors.border.main};
  }

  img {
    width: 6.4rem;
    height: 6.4rem;
    margin-top: -0.5rem;
  }

  p {
    line-height: 2rem;

    &:first-of-type {
      margin-bottom: 0.6rem;
    }

    &:not(:first-of-type) {
      color: ${({ $isDark }) => ($isDark ? secondaryColors.grey[200] : secondaryColors.grey[900])};
    }
  }
`;
